<template>
  <div>
    <v-layout align-center>
      <v-flex shrink>
        <v-checkbox
          :disabled="toggling"
          :input-value="isProvider"
          class="ma-0"
          hide-details
          @mousedown.native="toggle"/>
      </v-flex>
      <v-flex
        v-if="error"
        grow>
        <div class="body-1">
          <a
            class="body-2 clickable"
            href="https://westernpower.com.au/power-outages/power-outages-map">
            Western Power</a>
          <template>
            <span class="ml-3 orange--text text--lighten-3">
              {{ error }}
            </span>
          </template>
        </div>
      </v-flex>
      <v-flex
        v-else
        grow>
        <div class="body-1">
          <a
            class="body-2 clickable"
            href="https://westernpower.com.au/power-outages/power-outages-map">
            Western Power</a>
          <template v-if="outages.length === 0">
            <span class="ml-3">
              No outage
            </span>
          </template>
          <template v-else-if="outages.length === 1">
            <span class="ml-3 red--text text--lighten-3">
              1 outage
            </span>
          </template>
          <template v-else>
            <span class="ml-3 red--text text--lighten-3">
              {{ outages.length }} outages
            </span>
          </template>
          <span v-if="suburb">in {{ suburb }}</span>
        </div>
      </v-flex>
      <v-flex shrink>
        <v-btn
          v-if="expand === 0 && outages.length > 0"
          class="ma-0"
          icon
          @click="expand = -1">
          <v-icon>expand_less</v-icon>
        </v-btn>
        <v-btn
          v-else
          :disabled="outages.length === 0"
          class="ma-0"
          icon
          @click="expand = 0">
          <v-icon>expand_more</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-progress-linear
      v-if="loading"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate/>
    <v-divider v-else/>
    <v-layout>
      <v-expansion-panel
        v-if="outages.length > 0"
        :value="expand">
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="outages"
            :pagination="pagination"
            hide-actions>
            <template
              slot="items"
              slot-scope="props">
              <td>
                <v-tooltip
                  transition="scale-transition"
                  left>
                  <span slot="activator">
                    {{ props.item.start | formatFn }}</span>
                  <span>{{ props.item.start | formatLLL }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip
                  transition="scale-transition"
                  left>
                  <span slot="activator">
                    {{ props.item.end | formatFn }}</span>
                  <span>{{ props.item.end | formatLLL }}</span>
                </v-tooltip>
              </td>
              <template v-if="props.item.type === 'unplanned'">
                <td class="red--text text--lighten-3">
                  {{ props.item.type }}
                </td>
              </template>
              <template v-else>
                <td class="orange--text text--lighten-3">
                  {{ props.item.type }}
                </td>
              </template>
            </template>
            <template slot="no-data"/>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "western-power",
  data () {
    return {
      error: null,
      expand: -1,
      headers: [
        {
          text: "Start",
          value: "start"
        },
        {
          text: "Estimated rectification",
          value: "end"
        },
        {
          text: "Type",
          value: "type"
        }
      ],
      isProvider: false,
      loading: false,
      outages: [],
      pagination: {
        sortBy: "start",
        descending: true,
        rowsPerPage: -1
      },
      suburb: "",
      toggling: false
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/outages/western_power`).
      then((r) => {
        this.suburb = r.data.suburb;
        this.outages = Array.from(r.data.outages);
      }).
      catch(() => {
        this.error = "Error";
        this.$emit("error");
      }).
      finally(() => this.loading = false);
    this.refresh();
  },
  methods: {
    refresh () {
      this.toggling = true;
      return this.$http.
        get(
          `/api/sites/${this.$route.params.id}/providers/western-power`,
          { headers: { "Cache-Control": "no-cache" } }
        ).
        then((r) => this.isProvider = r.data).
        catch(() => this.$emit("error")).
        finally(() => this.toggling = false);
    },
    toggle () {
      if (this.isProvider) {
        this.toggling = true;
        this.$http.
          delete(`/api/sites/${this.$route.params.id}/providers/western-power`).
          then(() => this.refresh()).
          catch(() => this.$emit("error")).
          finally(() => this.toggling = false);
      } else {
        this.toggling = true;
        this.$http.
          put(`/api/sites/${this.$route.params.id}/providers/western-power`).
          then(() => this.refresh()).
          catch(() => this.$emit("error")).
          finally(() => this.toggling = false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Outages/WesternPower.vue